/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixAccountGetCustomerPhoneAndConsentDetails = require('./phoenixAccountGetCustomerPhoneAndConsentDetails.graphql');
